import { store } from "../atoms";
import { themeAtom } from "../atoms/theme.atom";
import { Color } from "../utils/classes/Color";
import { isDarkMode } from "../utils/functions/misc/isDarkMode";

const themeMode = store.get(themeAtom).mode;

export const colors = {
  primary: Color.fromHex("#205496"),
  complement: isDarkMode(themeMode)
    ? Color.fromHex("#ddd378")
    : Color.fromHex("#F0E366"),
  text: isDarkMode(themeMode)
    ? Color.fromHex("#F2F7FC")
    : Color.fromHex("#040C15"),
  textReverse: !isDarkMode(themeMode)
    ? Color.fromHex("#F2F7FC")
    : Color.fromHex("#040C15"),
  white: Color.fromHex("#F2F7FC"),
  grey: Color.fromHex("#DEE0E4"),
  success: Color.fromHex("#b5e48c"),
  warning: Color.fromHex("#d97706"),
  error: Color.fromHex("#ef233c"),
  background: isDarkMode(themeMode)
    ? Color.fromHex("#040C15")
    : Color.fromHex("#ffffff"),
  lightBackground: isDarkMode(themeMode)
    ? Color.fromHex("#07121d")
    : Color.fromHex("#ffffff"),
  black: Color.fromHex("#07121d"),
  whiteShadow: isDarkMode(themeMode)
    ? Color.fromHex("#000000", 0)
    : Color.fromHex("#d9d9d9", 0.76),
  isDark: isDarkMode(themeMode),
};
